export default __webpack_public_path__ + "static/media/kardia.b2237141.png";